<template>

	<div id="card" class="sc-shadow">
		<p class="mt-1 title">
			<strong>{{ shuttle.serviceType.name }}</strong>
			<span v-if="shuttle.serviceType.description" class="text-info" v-b-tooltip="{title: shuttle.serviceType.description, html: true, customClass: 'info-popup',}"><md-icon :icon="'info'"/></span>
		</p>
		<b-row>
			<b-col style="width: 45%" class="img-col">
				<img :src="shuttle.serviceType.image" alt/>
			</b-col>
			<b-col style="width: 55%">
				<div class="text-right">
					<p v-if="shuttle.serviceType.maxPax > 0" class="p-icon">
						<md-icon icon="person_outline" /> Hasta {{ shuttle.serviceType.maxPax }}
					</p>
					<p class="p-icon">
						<md-icon v-if="shuttle.serviceType.maxSuitecases > 0 || shuttle.serviceType.suitecasesDescription != ''" icon="luggage" />
						<span v-if="shuttle.serviceType.maxSuitecases > 0">{{shuttle.serviceType.maxSuitecases}}</span>
					</p>

					<span v-if="shuttle.serviceType.suitecasesDescription" class="text-info" v-b-tooltip="{title: shuttle.serviceType.suitecasesDescription, html: true, customClass: 'info-popup'}">
						<md-icon :icon="'info'" />
					</span>
				</div>

				<div v-if="shuttle.meetAndGreet">
					<p class="m-0 text-right">
						<md-icon icon="sentiment_satisfied"/>
						Meet & greet
					</p>
				</div>
				<p class="m-0 price" v-if="bookInfoPrice > 0 && shuttle.currency.length===3">
					<span class="discount-price" v-if="bookInfoPriceNoDiscount > bookInfoPrice">${{ bookInfoPriceNoDiscountFormated }}<small>{{ shuttle.currency }}</small></span><br/>
					<strong class="text-uppercase price"
					>${{ bookInfoPriceFormated }}
						<small>{{ shuttle.currency }}</small></strong
					><br/>

					<small>{{ ticketLabel }}</small>
				</p>
				<p class="m-0" v-else>Unavailable</p>
			</b-col>
		</b-row>
		<b-row no-gutters>
			<b-col cols="1">
				<p class="mb-0 text-left" style="">
					<small
					><strong>Reembolsable</strong></small
					>
				</p>
			</b-col>
			<b-col v-if="showButtons">
				<div class="text-right" v-if="bookInfoPrice > 0">
					<b-button class="select-btn" @click="onSelect" variant="success">
            <span>
              Book <md-icon icon="play_arrow "/>
            </span>
					</b-button>
				</div>
			</b-col>
		</b-row>
	</div>
</template>

<script>
import MdIcon from '../../../../helpers/MdIcon.vue';
import numeral from 'numeral';

export default {
	components: {
		MdIcon
	},
	props: {
		showButtons: {type: Boolean, required: false, default: true},
		shuttle: {type: Object, required: true},
		ticket: {type: String, required: true},
	},
	data() {
		return {};
	},
	computed: {
		bookInfoPriceFormated() {
			return numeral(this.bookInfoPrice).format('0,0.[00]');
		},
		bookInfoPriceNoDiscountFormated() {
			return numeral(this.bookInfoPriceNoDiscount).format('0,0.[00] ');
		},
		bookInfoPrice() {
			return this.shuttle[this.ticket];
		},
		bookInfoPriceNoDiscount() {
			return this.shuttle[`roundtripNoDiscount`];
		},
		ticketLabel() {
			let label = "";
			switch (this.ticket) {
				case "roundtrip":
					label = "Viaje redondo"
					break;
				case "oneway":
					label = "Viaje sencillo"
					break;
			}
			return label

		}

	},
	methods: {
		onSelect() {
			this.$emit('rateSelected', this.shuttle);
		},
		onSelectWithOffer() {
			this.$emit('rateSelectedOffer', this.shuttle);
		}
	},
};
</script>

<style>
.info-popup .tooltip-inner {
	text-align: left;
}
</style>
<style scoped>
.discount-price {
	font-size: 16px;
	text-decoration: line-through;
}

.img-col img {
	max-width: 100%;
	max-height: 100px;
}

.img-col {
	text-align: center;
}

.select-btn {
	padding: 0.1rem 1rem;
	margin-top: 0.5rem;
	font-size: 0.9rem;
}

.select-icon {
	/*font-size: 18px;*/
}

.p-icon {
	letter-spacing: -1px;
	margin-bottom: 0;
	font-size: 14px;
	white-space: nowrap;
	display: inline;
	text-align: right;
}

.title {
	font-size: 16px;
	margin-bottom: 0.4rem;
}

#card {
	background-color: #f2f2f2;
	position: relative;
	border-radius: 8px;
	width: 100%;
	height: 200px;
	padding: 0.5rem 16px 0 16px;
}

.be-font-styled {
	/*color: #5636d7;*/
	font-size: 20px !important;
}

.price {
	color: #4f39cf;
	font-size: 20px;
	line-height: 20px;
	text-align: right;
}

.price small {
	font-weight: bold;
	color: #212529 !important;
	font-size: 70%;
}

.price-type {
	font-weight: 100;
	margin-bottom: 0 !important;
}
</style>
